import moment from 'moment';
import { fromRangeToArray, returnIconDays } from 'common/utils/dateUtils/date-utils';

class teamRequestCoincidencesController {
  constructor($rootScope, $scope, $timeout, teamRequestsService, vacationUserDataService,inceptionService) {
    'ngInject';
    this.rootScope = $rootScope;
    this.inceptionService = inceptionService;
    this.scope = $scope;
    this.timeout = $timeout;
    this.teamRequestsService = teamRequestsService;
    this.managerId = vacationUserDataService.getEmployee().userId;
    this.loaded = false;
  }

  $onInit() {
    this.id = this.createId();
    this.request.endDate = this.request.endDate || moment().format('YYYY-MM-DD');

    this.teamRequestsService.getCoincidences(this.managerId, this.request.startDate, this.request.endDate).then((response) => {
      this.coincidences = response;
      this.loaded = true;

      if(this.coincidences.length === 0) {
        return;
      }

      this.date = this.getDateOfFirstCoincidence(this.request, this.coincidences);
      this.periodInDays = this.loadPeriodInDays();
    });
  }

  getDateOfFirstCoincidence(request, coincidences) {
    const email = request.email;
    let firstCoincidence;

    coincidences.forEach(coincidence => {
      const sameEmail = email === coincidence.email;
      const coincidenceBefore = coincidence.startDate < firstCoincidence;

      if (!sameEmail && (!firstCoincidence || coincidenceBefore)) {
        firstCoincidence = coincidence.startDate;
      }
    });

    return new Date(firstCoincidence);
  }

  isAnyCoincidences() {
    if(!this.periodInDays) return false;
    let coincidencesExist = false;
    if (this.periodInDays.length !== 0) coincidencesExist = true;
    return coincidencesExist;
  }

  shouldDisplayList(){
    if(!this.loaded) return false;

    return this.isAnyCoincidences() ;
  }

  shouldDisplayNoCoincidences(){
    return this.loaded===true && !this.shouldDisplayList() ;
  }

  loadPeriodInDays() {
    this.ids=[];
    let list = [];
    let id = this.createId();
    let iconDays = returnIconDays(this.coincidences);
    this.coincidences.map((item) => {
      let name = item.name;
      let daysAvailables = item.daysAvailables;
      let email =  item.email;
      let employeeId = item.employeeId;
      let startDate = item.startDate || item.date;
      let endDate = item.endDate || item.date || new Date();
      let status = item.status || '';
      let periodId = id++;
      let type = item.type || '';
      let code = item.code || '';
      let periodInDays = fromRangeToArray(startDate, endDate, status, periodId, type, code, iconDays);

      if(this.ifObjectExists(list,periodInDays,employeeId)){
        this.insertDays(list,periodInDays,employeeId);
      }else{
        this.insertNewObject(list,employeeId,name,daysAvailables,periodInDays,periodId, email);
      }
    });

    return list;
  }

  ifObjectExists(list,periodInDays,employeeId) {
    return list.find((obj)=>{
      return obj.employeeId===employeeId;
    });
  }

  insertDays(list,periodInDays,employeeId) {
    list.forEach((obj) => {
      if(obj.employeeId===employeeId){
        periodInDays.forEach((day) => {
          obj.periodInDays.push(day);
        });
      }
    });
  }

  insertNewObject(list,employeeId,name,daysAvailables,periodInDays,periodId, email) {
    let object = { employeeId ,name, daysAvailables, periodInDays, email};
    list.push(object);
    this.setRowIds(periodId);
  }

  setRowIds(periodId){
    this.ids.push(periodId);
  }

  nextPage() {
    let currentMonth = this.date.getMonth();
    this.date = new Date(this.date.getFullYear(), currentMonth + 1, 1);
  }

  prevPage() {
    let currentMonth = this.date.getMonth();
    this.date = new Date(this.date.getFullYear(), currentMonth - 1, 1);
  }

  generateIdFromPeriod(startDate,endDate) {
    const millenium = 2000;
    let generatedId = (startDate[0] - millenium) + startDate[1] + endDate[2];
    return generatedId;
  }

  createId() {
    let startDate= this.request.startDate.split('-');
    let today = new Date();
    let endDate = [today.getDay(), today.getMonth(), today.getFullYear()] ;
    if(this.request.endDate){
      endDate = this.request.endDate.split('-');
    }
    let constructId =  this.generateIdFromPeriod(startDate,endDate);
    let hash = `${this.request.employeeId}${constructId}`;
    return hash;
  }

  inceptEmployee( $event ) {
    if (this.isDisabledByDelegation) {
      return this.showModalWarningDelegation();
    }

    this.inceptionService.incept($event.employeeId, 'team-requests');
  }

}

export default teamRequestCoincidencesController;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestCard/teamRequestCardDetails/teamRequestCoincidences/teamRequestCoincidences.controller.js